/**
 * Embedded-wasm helpers. Engine kernels (AssemblyScript under assembly/) ship
 * as base64 TypeScript modules generated by scripts/build-wasm.mjs, so every
 * bundle format carries them with no asset plumbing. These helpers turn that
 * string back into a module in browsers, workers and Node alike.
 */

/** True when this runtime can instantiate WebAssembly at all. */
export function wasmAvailable(): boolean {
  return typeof WebAssembly !== 'undefined' && typeof WebAssembly.instantiate === 'function';
}

/** Decode a base64 string to bytes (atob in browsers/workers, Buffer in Node). */
export function decodeBase64(b64: string): Uint8Array {
  if (typeof atob === 'function') {
    const bin = atob(b64);
    const out = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
    return out;
  }
  const B = (globalThis as { Buffer?: { from(s: string, enc: string): Uint8Array } }).Buffer;
  if (B) return new Uint8Array(B.from(b64, 'base64'));
  throw new Error('decodeBase64: no atob or Buffer in this runtime');
}

/**
 * Instantiate an embedded kernel. Always async: Chrome refuses synchronous
 * compilation of modules over 4 KiB on the main thread, and every kernel
 * caller has a boot-time hook to await this from.
 */
export async function instantiateEmbeddedWasm<T extends WebAssembly.Exports>(
  b64: string,
  imports: WebAssembly.Imports = {},
): Promise<T> {
  const bytes = decodeBase64(b64);
  const module = await WebAssembly.compile(bytes as BufferSource);
  const instance = await WebAssembly.instantiate(module, imports);
  return instance.exports as T;
}
